import { render, staticRenderFns } from "./accountTransactionPaymentsRecord.vue?vue&type=template&id=0d784f52"
import script from "./accountTransactionPaymentsRecord.vue?vue&type=script&lang=js"
export * from "./accountTransactionPaymentsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports